import "../common/elements/Header.scss";
import AppBar from "@/features/common/elements/AppBar";
import MainSideNavBar from "@/features/common/elements/MainSideNavBar";
import { Institution } from "../common/interfaces/Interface";

export const PlanningHeaderSidebar = ({
  institution,
  componentLoaded,
  children
}: {
  institution: Institution;
  componentLoaded: {
    selectedTab: string;
    collapseSideNav: boolean;
    openPreviewModal: boolean;
    institution: boolean;
    membership: boolean;
  };
  children: JSX.Element;
}) => {
  return (
    <div className="pagewrapper">
      {institution && <AppBar institution={institution} />}
      <div className="nav-main">
        {institution && (
          <MainSideNavBar
            institution={institution}
            collapseSideNav={componentLoaded.collapseSideNav}
          />
        )}
        <div className="contentwrapper">{children}</div>
      </div>
    </div>
  );
};
